import { useCallback, useEffect, useState } from "react";
import FocusLock from "react-focus-lock";
import { TfaMethod } from "@/core/constants/tfaMethod";
import { ValidateCode } from "@/shared/ui";
import useChangePassword from "@/domains/playerMenu/hooks/useChangePassword";
import useGetCodeTimer from "@/domains/playerMenu/hooks/useGetCodeTimer";

type Props = {
  address: string;
  goToChangePassword: () => void;
};

export default function PlayerMenuSettingsSafetyChangePasswordEmailCheckContainer({
  address,
  goToChangePassword,
}: Props) {
  const [code, setCode] = useState<string>("");
  const {
    sendCodeHandler,
    sendIsPending,
    sendError,
    checkCodeHandler,
    checkIsPending,
    checkIsCompleted,
    checkError,
  } = useChangePassword();

  const { getTimer, timer } = useGetCodeTimer();

  useEffect(() => {
    getTimer({ type: "email", payload: address });
  }, []);

  const onSubmit = useCallback(async () => {
    checkCodeHandler(code);
  }, [code]);

  const onSendCodeHandler = useCallback(async () => {
    await sendCodeHandler(address, TfaMethod.EMAIL);
    await getTimer({ type: "email", payload: address });
  }, [address]);

  useEffect(() => {
    if (checkIsCompleted) {
      goToChangePassword();
    }
  }, [checkIsCompleted, goToChangePassword]);

  return (
    <FocusLock className="contents">
      <div className="h-full flex flex-col">
        <ValidateCode
          title="Введите проверочный код, отправленный вам почту"
          address={address}
          type={TfaMethod.EMAIL}
          code={code}
          onCodeChange={setCode}
          onSubmit={onSubmit}
          onSendCode={onSendCodeHandler}
          pending={checkIsPending}
          error={checkError || sendError}
          sendCodePending={sendIsPending}
          timer={timer}
        />
      </div>
    </FocusLock>
  );
}
